import { defineStore } from 'pinia';
import axios from 'axios';

const apiClient = axios.create({
    baseURL: '/',
    withCredentials: true, // required to handle the CSRF token
});

// eslint-disable-next-line import/prefer-default-export
export const useNotificationsStore = defineStore('notifications', {
    state: () => ({
        loading: false,
        page: 0,
        notifications: [],
    }),
    getters: {
        unreadNotifications(state) {
            return state.notifications.filter((not) => !not.read_at);
        },
    },
    actions: {
        async getNotifications() {
            this.loading = true;
            try {
                const response = await apiClient.get('/vue/notifications?status=unread');
                this.notifications = response.data;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
            this.loading = false;
        },
        async markNotificationAsRead(notification) {
            this.loading = true;
            try {
                await apiClient.post('/vue/notifications/' + notification.id + '/read');
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
            await this.getNotifications();
        },
    },
});
